import { createAction, props } from '@ngrx/store'
import { TeamComparisonPayload } from '@pages/team/models/team.models'
import { MetricMap } from '@core/models/metric.models'
import { Team } from '@core/models/team.models'
import { Player } from '@core/models/player.models'
import { ViewType } from '@pages/team/enums/team.enums'
import { EntitySelection } from '@features/selections/models/entity-selector.models'
import { Aggregation, AggregationSelectable } from '@features/aggregations/models/aggregations.models'

export const initializeTeam = createAction('[Team] Initialize team')
export const fetchTeamSummary = createAction('[Team] Fetch team summary')
export const setTeamSummary = createAction('[Team] Set team summary', props<{ summary: Team }>())
export const setTeamLoader = createAction('[Team] set team loader', props<{ teamLoading: boolean }>())

export const setTeamALoader = createAction('[Team] Fetch team A loader', props<{ teamALoading: boolean }>())
export const setTeamBLoader = createAction('[Team] Fetch team B loader', props<{ teamBLoading: boolean }>())

export const fetchTeamData = createAction('[Team] Fetch team data', props<{ team: Team }>())

export const updateTeamSelection = createAction('[Team] Update team selection', props<{ selection: EntitySelection }>())

export const fetchTeamPlayers = createAction(
  '[Team] Fetch team players',
  props<{ team: Team; aggregation?: Aggregation }>()
)
export const setTeamPlayers = createAction('[Team] Set team players', props<{ players: Player[] }>())
export const setTeamPlayerAggregation = createAction(
  '[Team] Set team player aggregation',
  props<{ playerAggregation: AggregationSelectable }>()
)

export const fetchTeamMetrics = createAction('[Team] Fetch team metrics', props<{ team: Team }>())
export const setTeamMetrics = createAction('[Team] Set team metrics', props<{ metrics: MetricMap }>())
export const setTeamMetricsLoader = createAction('[Team] Set team metrics loader', props<{ metricsLoading: boolean }>())

export const setTeamSelectedView = createAction('[Team] set team selected view', props<{ selectedView: ViewType }>())

export const setTeamTabs = createAction('[Team] Set team tabs', props<{ tabs: string[] }>())
export const setTeamActiveTabIndex = createAction('[Team] Active tab index', props<{ activeTabIndex: number }>())
export const setTeamComparisonActiveTabIndex = createAction(
  '[Team] Comparison active tab index',
  props<{ comparisonActiveTabIndex: number }>()
)

export const compareTeams = createAction('[Team] Compare teams', props<{ payload: TeamComparisonPayload }>())
export const setTeamB = createAction('[Team] Set team B', props<{ teamB: Team }>())

export const setTeamPlayersViewLoader = createAction(
  '[Team] set players view loader',
  props<{ playersViewLoader: boolean }>()
)

export const purgeTeam = createAction('[Team] purge team')

export const refreshTeam = createAction('[Team] refresh')
